import { ExternalLicenseEditScreen } from "./external-license-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const ExternalLicensesRoutes: RouteDefinition[] = [
	{
		path: Paths.externalLicenses.withIdPlaceholder().edit.path,
		element: <ExternalLicenseEditScreen />,
		requiredPermissions: [
			"UserInAccountPermission_ExternalLicenseAdmin_Read",
			"UserInAccountPermission_ExternalLicenseAdmin_Modify",
		],
	},
];
